import { render, staticRenderFns } from "./StudentAbsent.vue?vue&type=template&id=d23d4d12&"
import script from "./StudentAbsent.js?vue&type=script&lang=js&"
export * from "./StudentAbsent.js?vue&type=script&lang=js&"
import style0 from "./StudentAbsent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports